import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import { getTenantHeaders } from '../config/tenant';
import { Course } from '../types/course';

interface SuggestedCoursesEnvelope {
  success?: boolean;
  Success?: boolean;
  message?: string;
  Message?: string;
  data?: SuggestedPage | null;
  Data?: SuggestedPage | null;
}

interface SuggestedPage {
  currentPage?: number;
  CurrentPage?: number;
  pageSize?: number;
  PageSize?: number;
  totalPages?: number;
  TotalPages?: number;
  totalCount?: number;
  TotalCount?: number;
  data?: RawCourse[] | null;
  Data?: RawCourse[] | null;
}

interface RawCourse {
  id?: string;
  Id?: string;
  courseName?: string;
  CourseName?: string;
  term?: string;
  Term?: string;
  active?: boolean;
  Active?: boolean;
  price?: number;
  Price?: number;
  grade?: string;
  Grade?: string;
  description?: string;
  Description?: string;
  imagePath?: string;
  ImagePath?: string;
  modificationDate?: string;
  ModificationDate?: string;
  isSuggested?: boolean;
  IsSuggested?: boolean;
}

function normalizeCourse(raw: RawCourse): Course {
  return {
    id: String(raw.id ?? raw.Id ?? ''),
    courseName: raw.courseName ?? raw.CourseName ?? '',
    term: raw.term ?? raw.Term,
    active: raw.active ?? raw.Active,
    price: raw.price ?? raw.Price ?? 0,
    grade: raw.grade ?? raw.Grade,
    description: raw.description ?? raw.Description ?? '',
    imagePath: raw.imagePath ?? raw.ImagePath ?? '',
    modificationDate: raw.modificationDate ?? raw.ModificationDate ?? '',
  };
}

/** GET /api/Course/suggested — active courses flagged IsSuggested */
export async function fetchSuggestedCourses(
  pageNumber = 1,
  pageSize = 6
): Promise<Course[]> {
  const response = await axios.get<SuggestedCoursesEnvelope>(
    `${BASE_URL}api/Course/suggested`,
    {
      params: { pageNumber, pageSize },
      headers: {
        'Content-Type': 'application/json',
        ...getTenantHeaders(),
      },
    }
  );

  const body = response.data;
  const ok = body.success === true || body.Success === true;
  const page = body.data ?? body.Data;
  const list = page?.data ?? page?.Data;

  if (!ok || !Array.isArray(list)) {
    return [];
  }

  return list
    .map(normalizeCourse)
    .filter((c) => Boolean(c.id && c.courseName));
}
